import { render } from "./FullOrder.vue?vue&type=template&id=3f843f50&scoped=true&ts=true"
import script from "./FullOrder.vue?vue&type=script&lang=ts"
export * from "./FullOrder.vue?vue&type=script&lang=ts"

import "./FullOrder.vue?vue&type=style&index=0&id=3f843f50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f843f50"]])

export default __exports__